module.exports = __webpack_public_path__ + "img/img16.90e60628.jpg";